import { createClient } from "@supabase/supabase-js";
import { Database, definitions } from "../../../../supabase-types";

//Note: This may cause problems when running in react mode
if (process.env.NODE_ENV === "test") {
  const dotenv = require("dotenv");
  const path = require("path");
  const fs = require("fs");
  // Try .env.dev first (which should be merged with .env.base by propagateEnv), then fallback for backwards compatibility
  const envFiles = [".env.dev", ".env.staging", ".env.prod", ".env.base", ".env"];
  let envPath = null;
  for (const envFile of envFiles) {
    const testPath = path.join(__dirname, "../../..", envFile);
    if (fs.existsSync(testPath)) {
      envPath = testPath;
      break;
    }
  }
  if (envPath) {
    dotenv.config({ path: envPath });
  }
}

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseKey = process.env.REACT_APP_ANON_KEY!;

export const supabase = createClient<Database>(supabaseUrl, supabaseKey);
export type { Database, definitions };

//npx openapi-typescript https://ohbqevxlqqzzqxpqkbti.supabase.co/rest/v1/?apikey=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9oYnFldnhscXF6enF4cHFrYnRpIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NDg2OTM5MjQsImV4cCI6MTk2NDI2OTkyNH0.-tpXk4U-xd2JtY5vcAS4y1qu3Xkt4JpHJiZerboH2wI --output types/supabase.ts
